import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription, timer} from 'rxjs';
import {delay, filter, finalize} from 'rxjs/operators';

import {GetJasoFromString, JASO} from '../shared/defines/gukeo.const';
import {
  DETAIL_POPUP_DELAY,
  HISTORY_KEY_SEARCH_SASEUNG,
  SearchParam, UI_RELOAD_HEIGHT
} from '../shared/defines/client.const';
import {GetSearchFromQuery} from "../shared/defines/client.func";
import {MENU_PAGE, PRELOAD_RATIO} from '../shared/defines/desktop.const';
import {ListLoader} from '../shared/interfaces/list-loader';
import {GlobalEventService} from "../shared/services/global-event/global-event.service";
import {JasoIndexSeungjoComponent} from "../shared/components/jaso-index/jaso-index-seungjo.component";
import {RedPipeService} from "../shared/services/red-pipe/red-pipe.service";
import {SaseungHangulService} from "../shared/services/saseung-hangul/saseung-hangul.service";


@Component({
  selector: 'app-saseung',
  templateUrl: './saseung.component.html',
  styleUrls: ['./saseung.component.scss']
})
export class SaseungComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('container') container?: ElementRef;
  @ViewChild('reload') reload?: ElementRef;
  @ViewChild('main', { static: true }) main?: ElementRef; // ngOnInit() 에서 사용 가능

  // 화면 사이즈 맞춤에 사용
  @ViewChild('extContainer') extContainer?: ElementRef;
  @ViewChild(JasoIndexSeungjoComponent) extHeader?: JasoIndexSeungjoComponent;
  @ViewChild('extBody') extBody?: ElementRef;

  protected readonly MENU_PAGE = MENU_PAGE;
  protected readonly HistoryKeySearchWord = HISTORY_KEY_SEARCH_SASEUNG;
  protected readonly HISTORY_KEY_SEARCH_SASEUNG = HISTORY_KEY_SEARCH_SASEUNG;
  private inited = false;

  // 라우터에서 넣어주는 값. (TODO: 초기화에 유의해야 함)
  private queryParams: SearchParam | null = null;

  // 해더에 넣는 값
  public curJasoIdx: JASO | null = null;
  public keyword: string | null = null;
  public placeholder = "각 문자의 사 성과 훈 풀이를 볼 수 있습니다."
  protected scrollTop = true;

  // ListLoader 설정
  ll: ListLoader<string> | null = null;
  private getNextList$: Subscription | null = null;
  private needReload = false;

  private queryParams$?: Subscription;
  private params$?: Subscription;

  // 상세화면 표시 관련 정의
  public curHangul: string | null = null; // 현재 선택된 단어

  // 외부 링크로 hun 값이 들어오는 경우.
  protected hun: string | null = null;
  protected hanja: string | null = null;

  // 화면 크기 조정
  private bodyHeight = UI_RELOAD_HEIGHT;

  // 스크롤바 표시 여부
  protected isShowScrollbar = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private saseungHangulSvc: SaseungHangulService,
    private globalEventSvc: GlobalEventService,
    private redPipeSvc: RedPipeService,
  ) {
    // super(globalEventSvc);

    /******************************************************************************************
     * 라우터 파리미터 변경 핸들러 - 주소 뒤의 파라미터를 받아오는 곳. ( ?keyword=... )
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * 처음 화면에 들어올 때, 라우터 주소 변견 핸들러보다 더 먼저 불려진다. (이상하지만 그렇다)
     *
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams
      .subscribe(params => {
        console.log('route.queryParams( params =', params);
        this.queryParams = {...params};
        delete this.queryParams.serial;

        if (this.inited) {
          // 라우터 주소 변경 핸들러로 들어와서 init()이 처음 불려진 경우 = 이미 화면이 목록이 불려진 경우 = 목록이 초기화되어있는 경우!
          // 이 조건을 안 걸면 init()가 두번 불려진다.

          // 현재 목록에서 지정한 사성 항목이 존재하는지 확인
          if (this.queryParams.id) {
            const id = this.queryParams.id;
            this.keyword = this.queryParams.keyword ?? null;

            const processParams = () => {
              // console.log('processParams()');
              const saseung = this.ll?.getById(id) ?? null;
              if (saseung) {
                this.CloseDetail();
                timer(DETAIL_POPUP_DELAY).subscribe(() => {
                  this.OpenDetail(saseung);
                });
              }
              else {
                // 존재하지 않으면 다른 자소색인을 로딩한 후 연다.
                const jaso = id ? GetJasoFromString(id) : null;
                console.warn('does not exist saseung', id, jaso);
                // @ts-ignore
                this.queryParams.index = jaso;
                this.init();
              }
            };

            if (this.ll?.IsLoading()) {
              // 이 시점에서 아직 목록 로딩이 안 끝났을 수 있다.
              this.ll.GetNextList().pipe(
                delay(DETAIL_POPUP_DELAY),
              ).subscribe(processParams);
            }
            else {
              processParams();
            }
          }
          else {
            // 다시 서버에서 받아온다.
            this.init();
          }
        }
      });

    /******************************************************************************************
     * 라우터 주소 변경 핸들러 - 라우터 주소 읽어오는 곳.
     * 라우터 주소에 포함된 파라미터가 변경되어도 불려진다. (여기서는 type만 변경되어도 불려짐)
     *
     * queryParams가 바뀐 것(주소뒤의 파리미터가 변경된 경우)으로는 여기가 불려지지 않는다.
     */
    this.params$ = route.params.subscribe(params => {
      console.log('params.subscribe( params =', params);
      this.inited = true;

      this.init();
    });

    // lm.Reset();
  }

  ngOnInit() {
    // if (this.main) {
    //   this.InitFocusMain(this.main);
    // }
    // else {
    //   console.error('SaseungComponent::ngOnInit() main is null');
    // }
  }

  ngAfterViewInit() {
    this.updateExtHeight();

    // 최초 로딩 시, 화면 배치가 어그러지는 것을 고치기위한 코드. (TODO: 효과 있는지 확인 후 필요시 제거)
    timer(2000).subscribe(() => {
      this.updateExtHeight();
    });
  }

  ngOnDestroy() {
    // this.ExitFocusMain();
    this.queryParams$?.unsubscribe();
    this.params$?.unsubscribe();
    this.getNextList$?.unsubscribe();
  }

  private init(): void {
    console.log('init()', this.queryParams);

    this.curHangul = null;
    this.ll = this.saseungHangulSvc;

    let param: SearchParam;

    if (this.queryParams?.id) {
      const jaso = GetJasoFromString(this.queryParams.id);
      param = jaso ? { index: jaso } : {};
      this.curJasoIdx = jaso;
      this.keyword = null;
      this.hun = null;
      this.hanja = null;
    }
    else if (this.queryParams?.hun) {
      [param, this.curJasoIdx, this.keyword] = GetSearchFromQuery(this.queryParams);
      this.resetParams();
      this.hun = this.queryParams.hun;
    }
    else if (this.queryParams?.hanja) {
      [param, this.curJasoIdx, this.keyword] = GetSearchFromQuery(this.queryParams);
      this.resetParams();
      this.hanja = this.queryParams.hanja;
    }
    else {
      [param, this.curJasoIdx, this.keyword] = GetSearchFromQuery(this.queryParams);
      this.hun = null;
      this.hanja = null;
    }

    this.ReloadList(param);
  }

  private resetParams(): void {
    this.curHangul = null;
    this.keyword = null;
    this.hanja = null;
    this.hun = null;
  }

  /****************************************************************************
   * 브라우저 크기 변경 처리.
   ****************************************************************************/

  // 'resize' 이벤트를 감지하고 이벤트 발생 시 updateHeight 메소드를 호출합니다.
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.updateExtHeight();
  }

  private updateExtHeight(): void {
    if (this.extContainer && this.extHeader && this.extBody) {
      const containerHeight = this.extContainer.nativeElement.offsetHeight;
      const headerHeight = this.extHeader.offsetHeight;
      this.bodyHeight = containerHeight - headerHeight - 34;
      this.extBody.nativeElement.style.setProperty('max-height', this.bodyHeight + 'px');
    }
  }

  /****************************************************************************
   * 단어 목록 로딩 처리.
   ****************************************************************************/


  public ReloadList(param: SearchParam): void {


    this.ll?.ResetList(param);
    this.loadList(true);
  }

  private loadList(cancel = false): void {
    if (this.getNextList$) {
      console.warn('SaseungComponent::loadList() already call loadList!');
      if (cancel) {
        this.getNextList$.unsubscribe();
      }
      else {
        return;
      }
    }

    if (this.ll?.IsComplete()) {
      console.warn('SaseungComponent::loadList() already load all word!');
      return;
    }

    // 첫번째 로딩 시 위치 계산을 해야 한다.
    if (this.ll) {
      this.getNextList$ = this.ll.GetNextList()
        .pipe(
          filter(first => first),
          delay(DETAIL_POPUP_DELAY),
          finalize(() => {
            this.getNextList$ = null;

            // 변수에 스크롤바 표시 상태를 저장
            const elContainer = this.container?.nativeElement;
            if (elContainer) {
              this.isShowScrollbar = elContainer.scrollHeight > elContainer.clientHeight;
              console.warn('ngAfterViewInit() showScrollbar =', this.isShowScrollbar, elContainer.scrollHeight, elContainer.clientHeight);
            }

            if (this.needReload) {
              timer(0).subscribe(() => {
                this.needReload = false;
                this.loadList();
              });
            }
          })
        )
        .subscribe(
          () => {
            console.log('SaseungComponent::loadList() done', this.queryParams);
            if (this.queryParams?.id) {
              const saseung = this.ll?.getById(this.queryParams.id);
              if (saseung) {
                this.OpenDetail(saseung);
              }
            }
            else {
              const first = this.ll?.getList()?.at(0);
              if (first && !(this.keyword || this.hun || this.hanja)) {
                // 첫번째 페이지 로딩이면서, 검색어, 훈, 한자가 없으면 자동으로 첫번째 단어를 보여준다.
                first && this.OpenDetail(first);
              }
            }
          }
        );
    }
  }


  /****************************************************************************
   * 일정 범위 이상 스크롤되면 남은 단어를 자동 로딩한다.
   ****************************************************************************/
  onScroll($event: Event): void {
    // console.log('SaseungComponent::onScroll()');

    if (this.container === undefined) {
      throw new Error('WordComponent::onScroll() - #container  does not exist!!');
    }

    if (this.ll && !this.ll.IsLoading() && !this.ll.IsComplete() && this.reload) {
      const tar = $event.target || $event.srcElement || $event.currentTarget;
      const elContainer = this.container.nativeElement;
      if (tar !== elContainer) {
        console.error('WordComponent::onScroll() - wrong structure!!');
      }
      // console.log('onScroll() event =', $event,. tar);

      const elReload = this.reload.nativeElement;
      // console.log('onScroll() ', elReload.offsetTop, elReload.scrollTop, tar.offsetTop, tar.scrollTop, window.innerHeight);

      // console.warn('onScroll() ', elReload.offsetTop, elContainer.scrollTop, this.bodyHeight, elContainer.scrollTop + PRELOAD_RATIO * this.bodyHeight);
      if (elReload.offsetTop < elContainer.scrollTop + PRELOAD_RATIO * this.bodyHeight) {
        this.loadList();
      }
      else {
        // 스크롤 중에 이미 로딩이 진행되고 있으면, 로딩이 끝난 뒤에 다시 로딩이 되도록 요청. (비동기처리 순서 꼬임 방지)
        this.needReload = true;
      }
    }
  }


  protected onScrollTop($event: Event): void {
    const target = $event.target as HTMLElement;

    // console.log('onScrollTop() ', target.scrollTop);
    this.scrollTop = target.scrollTop === 0; // 수직 스크롤 위치
  }

  protected onClickRope($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    this.container?.nativeElement.scrollTo({
      top: 0,
      behavior: 'smooth',
      // behavior: 'auto',
    });

    this.redPipeSvc.Click($event);
  }

  /****************************************************************************
   * 단어 상세 팝업창 처리 코드
   ***************************************************************************/

  protected onSelectChar($event: MouseEvent, saseung: string): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    const queryParams = {
      ...(this.queryParams || {}),
      id: saseung,
    };
    // Spec: docs/page_common_logic.md > 선택 URL 히스토리와 start/id 보존
    this.router.navigate(['/saseung-old'], {queryParams}).then();
  }


  public onSearch(param: SearchParam): void {
    // 단어 이력보기 화면에서 자소를 선택하면 단어 검색으로 변경한다.
    // if (this.ll instanceof WordHistoryService && ('index' in param || 'keyword' in param)) {
    //   console.warn('ReloadWordList:: ll, param', this.ll, param);
    //   this.router.navigate(['/word', LIST_TYPE.SERVER], {
    //     queryParams: {...param}
    //   }).then();
    //   return;
    // }

    this.router.navigate(['/saseung-old'], {
      queryParams: param,
    }).then();
  }


  /**
   * 사성 상세 보기
   *
   * @param $event - MouseEvent
   * @param saseung - 선택된 Sasegun 객체
   */
  public OpenDetail(saseung: string, $event: MouseEvent | null = null): void {

    this.curHangul = saseung;
    // if (!(this.ll instanceof WordHistoryService)) {
    //   this.historySvc.addHistory(word.id);
    // }
  }

  /**
   * 상세 팝업창을 닫았을 때의 이벤트 처리 함수
   */
  public CloseDetail(): void {
    console.log('CloseDetail()');

    if (this.curHangul) {
      // this.naviSvc.push(['/saseung', this.type], {id: this.curDetail.hangul});
      this.curHangul = null;
    }
  }

}
